import React from 'react'
import {FORM_FIELDS_INITIAL_RULE_LOOKUP_TABLE, ACCOUNT_REGION_CROSS_BORDER, DAILY} from '../../../../../constants';
const OtherSweepOptions = ({item,pageJson,sweepParticipantsAccounts,standardSweepInstructions,translations,translateWordForOption}) => {
  if(item !== undefined) {
    var visibleFields = FORM_FIELDS_INITIAL_RULE_LOOKUP_TABLE['sweep-other-sweep-options'][sweepParticipantsAccounts.sweepType.value]['visibleFields'];

    // let OtherSweep = visibleFields.map((fieldsData) => {
    //       console.log(fieldsData);
    //       return(<div><dt>{translations(pageJson.fieldsData)}</dt>
    //       <dd>{item.fieldsData}</dd></div>)
    //  })
     let reverseSweepHolidaySkipOption = () => {
       var status = false;
        if(standardSweepInstructions.reverseSweepOption.value ==='yes'){
         status = true
       }
       return status
     }

     let holidayAdjustmentOption = () => {
       var status = false;
        if(sweepParticipantsAccounts.accountRegion === ACCOUNT_REGION_CROSS_BORDER
           && standardSweepInstructions.sweepFrequency.frequencyType.value !== DAILY){
           status = true
       }
       return status
     }

    return (
      <div className="cc-detail-container gdocs-mleft-25">
        <div className="cc-detail-container__heading">{translations(pageJson.pageHeading)}</div>
        <div className="cc-detail-container__content">
          <dl className="cc-detail-container__horizontal-row">
          {
            visibleFields.includes('fixedAmount')
            ? [
                <dt>{'Fixed Amount'}</dt>,
                <dd>{item.fixedAmount}</dd>
              ]
            : null
          }
          {
            visibleFields.includes('percentage')
            ? [
                <dt>{'Percentage'}</dt>,
                <dd>{item.percentage}</dd>
              ]
            : null
          }
            {
              visibleFields.includes('csrMasterAcount')
              ? [
                  <dt>{translations(pageJson.textCSRMaster)}</dt>,
                  <dd>{item.csrMasterAcount}</dd>
                ]
              : null
            }
            {
              visibleFields.includes('csrSubAccount')
              ? [
                  <dt>{translations(pageJson.textCSRSub)}</dt>,
                  <dd>{item.csrSubAccount}</dd>
                ]
              : null
            }
            {
              visibleFields.includes('percentageGroupSweepRule')
              ? [
                  <dt>{'Percentage Group Sweep Rule'}</dt>,
                  <dd>{item.percentageGroupSweepRule !== undefined && item.percentageGroupSweepRule.name ? item.percentageGroupSweepRule.name : ''}</dd>
                ]
              : null
            }
            {
              visibleFields.includes('holidayAdjustmentOption') && holidayAdjustmentOption()
              ? [
                  <dt>{translations(pageJson.textHolidayAdjustmentOption)}</dt>,
                  <dd>{item.holidayAdjustmentOption !== undefined && item.holidayAdjustmentOption.name !== undefined ? item.holidayAdjustmentOption.name : ''}</dd>
                ]
              : null
            }
            {
              visibleFields.includes('creditFirstGroupSweepRule')
              ? [
                    <dt>{'Credit First Group Sweep Rule'}</dt>,
                  <dd>{item.creditFirstGroupSweepRule !== undefined && item.creditFirstGroupSweepRule !== undefined ? item.creditFirstGroupSweepRule.name : ''}</dd>
                ]
              : null
            }
            {
              visibleFields.includes('reverseSweepHolidaySkip') && reverseSweepHolidaySkipOption()
              ? [
                  <dt>{translations(pageJson.textReverseSweepHoliday)}</dt>,
                  <dd>{item.reverseSweepHolidaySkip !== undefined && item.reverseSweepHolidaySkip.name !== undefined ? item.reverseSweepHolidaySkip.name : ''}</dd>
                ]
              : null
            }
            {
              visibleFields.includes('weightedAverageGroupSweepRule')
              ? [
                  <dt>{translations(pageJson.textWeightedAverageGroup)}</dt>,
                  <dd>{item.weightedAverageGroupSweepRule !== undefined && item.weightedAverageGroupSweepRule.name !== undefined ? item.weightedAverageGroupSweepRule.name : ''}</dd>
                ]
              : ''
            }
            {
              visibleFields.includes('dynamicSweepGroupSweepRule')
              ? [
                  <dt>{'Dynamic Sweep Group Rule'}</dt>,
                  <dd>{item.dynamicSweepGroupSweepRule !== undefined && item.dynamicSweepGroupSweepRule.name !== undefined ? item.dynamicSweepGroupSweepRule.name : ''}</dd>
                ]
              : ''
            }
            {
              visibleFields.includes('dynamicSweepPostingMethod')
              ? [
                  <dt>{'Dynamic Sweep Posting Method'}</dt>,
                  <dd>{item.dynamicSweepPostingMethod !== undefined && item.dynamicSweepPostingMethod.name !== undefined ? item.dynamicSweepPostingMethod.name : ''}</dd>
                ]
              : ''
            }
          </dl>
        </div>
      </div>
    )
  }else {
    return null;
  }
}

export default OtherSweepOptions;



// WEBPACK FOOTER //
// ./src/components/CaseList/PreviewGLS/CCPreview/SweepInstruction/OtherSweepOptions.js